import React from 'react';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import FormContainer from 'components/FormContainer';
import ShowInformation from 'components/ShowInformation';

const MetaInformation = ({created, origin}) => {

  return (
    <Card>
      <CardHeader>
        <div className="cardTitle">META INFORMATION</div>
      </CardHeader>
      <FormContainer>
        <ShowInformation title="CREATED" description={created} />
        <ShowInformation title="ORIGIN" description={origin} />
      </FormContainer>
    </Card>
  )
}

export default MetaInformation;
